import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setProfile } from "../../onboarding/actions/onboardingActions";
import { getParticipantProfile } from "../../onboarding/services";

export const useParticipantProfile = () => {
  const params = useParams();
  const [participantProfile, setParticipantProfile] = useState({});
  const dispatch = useDispatch();

  useEffect(async () => {
    if (params.profileId) {
      try {
        const response = await getParticipantProfile(params.profileId);

        setParticipantProfile(response.data.data);
        dispatch(
          setProfile({
            isPasswordCreated: response.data.data.passwordCreated,
            profileId: response.data.data.participantProfileId,
            firstName: response.data.data.name,
            lastName: response.data.data.lastName,
            email: response.data.data.email,
          })
        );
      } catch (err) {
        // TODO: MANUEL LIZARRAGA ERROR HANDLER AND DELETE CONSOLE
        console.log(err);
      }
    }
  }, [params.profileId]);

  return {
    isPasswordCreated: participantProfile?.passwordCreated,
    participantProfileId: participantProfile?.participantProfileId,
  };
};
